<template>
  <v-dialog v-model="show" persistent max-width="25rem">
    <v-card>
      <v-card-title></v-card-title>
      <v-card-text
        style="min-height:5rem;display: flex;justify-content: center;align-items: center;"
        >해당 서비스는 휴대전화 인증 후 이용가능합니다.</v-card-text
      >
      <v-divider></v-divider>
      <v-card-actions class="pa-0">
        <v-btn
          v-if="back"
          width="50%"
          text
          large
          class="font-weight-bold"
          @click="goBack"
        >
          돌아가기
        </v-btn>
        <v-btn
          v-else
          width="50%"
          text
          large
          class="font-weight-bold"
          @click="close"
        >
          닫기
        </v-btn>
        <v-divider vertical></v-divider>
        <v-btn
          color="primary"
          width="50%"
          text
          large
          class="font-weight-bold"
          to="/phone/verify"
        >
          인증받으러 가기
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    close: Function,
    show: Boolean,
    back: Boolean
  },
  data() {
    return {
      on: true
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style></style>
